module.exports = __webpack_public_path__ + "static/media/tour-time.0b0e393b.svg";